import { Schema } from "effect";
import type { languages, editor } from "monaco-editor";

export const EditorJsonRequest = Schema.Union([
  Schema.TaggedStruct("Project", { authority: Schema.String }),
  Schema.TaggedStruct("Tokens", {})
]);
export type EditorJsonRequest = typeof EditorJsonRequest.Type;
const Offset = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0));
const Position = Schema.Struct({ line: Offset, character: Offset });
export const EditorJsonDiagnostics = Schema.Array(Schema.Struct({
  range: Schema.Struct({ start: Position, end: Position }),
  severity: Schema.optional(Schema.Number),
  code: Schema.optional(Schema.Union([Schema.String, Schema.Number])),
  message: Schema.String,
  source: Schema.optional(Schema.String)
}));
export type EditorJsonDiagnostic = (typeof EditorJsonDiagnostics.Type)[number];
export function jsonDiagnosticMarker(value: EditorJsonDiagnostic): editor.IMarkerData {
  const severity = value.severity === 1 ? 8 : value.severity === 2 ? 4 : value.severity === 4 ? 1 : 2;
  return {
    severity,
    startLineNumber: value.range.start.line + 1,
    startColumn: value.range.start.character + 1,
    endLineNumber: value.range.end.line + 1,
    endColumn: value.range.end.character + 1,
    message: value.message,
    code: typeof value.code === "number" ? String(value.code) : value.code,
    source: value.source
  };
}

// Immutable JSON configuration values from the installed 0.55.1 jsonMode.
// Each registration receives its own data; no native module is replaced.
export function makeJsonConfiguration(): languages.LanguageConfiguration {
  return {
    wordPattern: /(-?\d*\.\d\w*)|([^\[\{\]\}\:\"\,\s]+)/g,
    comments: { lineComment: "//", blockComment: ["/*", "*/"] },
    brackets: [["{", "}"], ["[", "]"]],
    autoClosingPairs: [
      { open: "{", close: "}", notIn: ["string"] },
      { open: "[", close: "]", notIn: ["string"] },
      { open: '"', close: '"', notIn: ["string"] }
    ]
  };
}
